import { MapPin, Phone, Clock, ArrowRight } from "lucide-react";

const MAP_EMBED =
  "https://www.google.com/maps?q=290+9th+Ave+NW,+Moose+Jaw,+SK&output=embed";
const MAP_DIRECTIONS =
  "https://www.google.com/maps/dir/?api=1&destination=290+9th+Ave+NW,+Moose+Jaw,+SK";

export default function VisitSection() {
  return (
    <section className="visit" id="visit" data-testid="visit-section">
      <div className="visit__inner">
        <div className="visit__copy">
          <span className="overline" >VISIT US</span>
          <h2 className="section-h2">Come meet the team.</h2>
          <ul className="visit__list">
            <li>
              <MapPin className="w-5 h-5 flex-shrink-0" style={{ color: "var(--pp-indigo)" }} />
              <span>290 9th Ave NW, Moose Jaw, SK S6H 4H2</span>
            </li>
            <li>
              <Phone className="w-5 h-5 flex-shrink-0" style={{ color: "var(--pp-indigo)" }} />
              <a href="tel:3066910001" data-testid="visit-phone-link">306-691-0001</a>
            </li>
            <li>
              <Clock className="w-5 h-5 flex-shrink-0" style={{ color: "var(--pp-indigo)" }} />
              <span>
                Mon–Fri 9–5 · Saturday 10–4 <span className="visit__hours-note">(placeholder hours)</span>
              </span>
            </li>
          </ul>
          <a
            href={MAP_DIRECTIONS}
            target="_blank"
            rel="noopener noreferrer"
            className="pp-btn-primary"
            data-testid="visit-directions-btn"
          >
            Get directions
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>

        <div className="visit__map">
          <iframe
            title="Pup's Parlour location map"
            src={MAP_EMBED}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            data-testid="visit-map-iframe"
          />
        </div>
      </div>
    </section>
  );
}
